import { supabaseClient } from "./client";

// We have a very large dataset for deals and supabase keeps timing out
// So we use pagination
export const getUniquePipelines = async (companyId: number) => {
  let uniquePipelines = new Set<string>();
  let lastPipeline: string | null = null;
  const limit = 1000;

  while (true) {
    let query = supabaseClient
      .from("deals")
      .select("pipeline")
      .eq("company_id", companyId)
      .not("pipeline", "is", null)
      .order("pipeline", { ascending: true })
      .limit(limit);

    if (lastPipeline) {
      query = query.gt("pipeline", lastPipeline);
    }

    const { data, error } = await query;

    if (error) {
      console.error("Error fetching pipelines", error);
      throw error;
    }

    if (!data || data.length === 0) {
      break; // no more data
    }

    data.forEach((deal) => uniquePipelines.add(deal.pipeline as string));

    lastPipeline = data[data.length - 1].pipeline as string;

    if (data.length < limit) {
      break; // last page
    }
  }

  const result = Array.from(uniquePipelines);
  return result;
};
